import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Sidebar.css';

function Sidebar({ currentPath }) {
  const { t } = useTranslation();
  const isActive = (path) => currentPath === path || currentPath.startsWith(path + '/');

  return (
    <div className="admin-sidebar">
      <h2>{t('admin.sidebar.title')}</h2>
      <nav>
        <ul className="admin-nav">
          <li>
            <Link to="/admin/dashboard" className={isActive('/admin/dashboard') ? 'active' : ''}>
              {t('admin.sidebar.dashboard')}
            </Link>
          </li>
          <li>
            <Link to="/admin/users" className={isActive('/admin/users') ? 'active' : ''}>
              {t('admin.sidebar.users_and_companies')}
            </Link>
          </li>
          <li>
            <Link to="/admin/licenses" className={isActive('/admin/licenses') ? 'active' : ''}>
              {t('admin.sidebar.licenses')}
            </Link>
          </li>
          <li>
            <Link to="/admin/email-log" className={isActive('/admin/email-log') ? 'active' : ''}>
              {t('admin.sidebar.email_log')}
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Sidebar;






